import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgS2 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 64 80",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(2 19)",
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsxs("g", {
			transform: "translate(5 3)",
			fill: "#1D1D1B",
			fillRule: "nonzero",
			children: [
				/* @__PURE__ */ _jsxs("g", {
					transform: "translate(2)",
					children: [
						/* @__PURE__ */ _jsx("rect", {
							x: 45,
							width: 2,
							height: 20,
							rx: .9
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 40,
							y: 24,
							width: 2,
							height: 15,
							rx: 1
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 5,
							y: 24,
							width: 2,
							height: 15,
							rx: 1
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 5,
							width: 2,
							height: 20,
							rx: .9
						}),
						/* @__PURE__ */ _jsx("rect", {
							width: 2,
							height: 20,
							rx: .9
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 40,
							width: 2,
							height: 20,
							rx: .9
						})
					]
				}),
				/* @__PURE__ */ _jsx("path", { d: "M17.23 6.09A7.5 7.5 0 0018.5 6a4.21 4.21 0 001.12-.37 2.71 2.71 0 00.85-.65 1.91 1.91 0 00.46-1h1.69v12.69h-2.27v-9h-3.12V6.09zM26.47 4H33v1.85h-5l-.65 3.23a2.57 2.57 0 011.06-.72 3.68 3.68 0 011.28-.25 4.31 4.31 0 011.69.32 3.52 3.52 0 011.25.89 3.9 3.9 0 01.77 1.35 5.41 5.41 0 010 3.25 4.52 4.52 0 01-.78 1.47 4.24 4.24 0 01-1.37 1.09 4.41 4.41 0 01-2 .43 5.893 5.893 0 01-1.71-.25 4.2 4.2 0 01-1.33-.66 3.65 3.65 0 01-1-1.21 4.27 4.27 0 01-.39-1.67h2.07a2.16 2.16 0 002.34 2.13 2.6 2.6 0 001.1-.21 2 2 0 00.74-.6 2.41 2.41 0 00.4-.89 4.74 4.74 0 00.11-1.09 3.31 3.31 0 00-.14-1 2.55 2.55 0 00-.44-.85 2.1 2.1 0 00-.7-.61 2.6 2.6 0 00-1.08-.21A3.12 3.12 0 0028 10a1.52 1.52 0 00-.83.92h-2.06L26.47 4z" }),
				/* @__PURE__ */ _jsx("rect", {
					transform: "rotate(135 4.59 27.59)",
					x: 3.684,
					y: 22.004,
					width: 1.81,
					height: 11.17,
					rx: .9
				}),
				/* @__PURE__ */ _jsx("rect", {
					transform: "rotate(45 46.59 27.59)",
					x: 45.684,
					y: 22.004,
					width: 1.81,
					height: 11.17,
					rx: .9
				})
			]
		}), /* @__PURE__ */ _jsx("rect", {
			stroke: "#0D0E10",
			strokeWidth: 2,
			x: -1,
			y: -1,
			width: 62,
			height: 28,
			rx: 2
		})]
	})
});
export default SvgS2;
